import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LocationProvider } from "@/context/LocationContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Transports from "@/pages/Transports";
import TransportDetail from "@/pages/TransportDetail";
import TransportForm from "@/pages/TransportForm";
import Fleet from "@/pages/Fleet";
import Chat from "@/pages/Chat";
import Announcements from "@/pages/Announcements";
import Documents from "@/pages/Documents";
import SmsLogs from "@/pages/SmsLogs";
import Reports from "@/pages/Reports";
import Agencies from "@/pages/Agencies";
import UsersPage from "@/pages/Users";
import Profile from "@/pages/Profile";
import More from "@/pages/More";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import OptIn from "@/pages/OptIn";
import Schedules from "@/pages/Schedules";
import TimeOff from "@/pages/TimeOff";
import DriverLog from "@/pages/DriverLog";

function Shell({ children, adminOnly }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <NotificationsProvider>
              <LocationProvider>
              <Toaster position="top-right" richColors />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/opt-in" element={<OptIn />} />

                <Route path="/" element={<Shell><Dashboard /></Shell>} />
                <Route path="/transports" element={<Shell><Transports /></Shell>} />
                <Route path="/transports/new" element={<Shell><TransportForm /></Shell>} />
                <Route path="/transports/:id" element={<Shell><TransportDetail /></Shell>} />
                <Route path="/transports/:id/edit" element={<Shell><TransportForm /></Shell>} />
                <Route path="/fleet" element={<Shell><Fleet /></Shell>} />
                <Route path="/chat" element={<Shell><Chat /></Shell>} />
                <Route path="/announcements" element={<Shell><Announcements /></Shell>} />
                <Route path="/documents" element={<Shell><Documents /></Shell>} />
                <Route path="/profile" element={<Shell><Profile /></Shell>} />
                <Route path="/more" element={<Shell><More /></Shell>} />
                <Route path="/schedules" element={<Shell><Schedules /></Shell>} />
                <Route path="/time-off" element={<Shell><TimeOff /></Shell>} />
                <Route path="/driver-log" element={<Shell><DriverLog /></Shell>} />

                <Route path="/sms-logs" element={<Shell adminOnly><SmsLogs /></Shell>} />
                <Route path="/reports" element={<Shell adminOnly><Reports /></Shell>} />
                <Route path="/agencies" element={<Shell adminOnly><Agencies /></Shell>} />
                <Route path="/users" element={<Shell adminOnly><UsersPage /></Shell>} />
              </Routes>
              </LocationProvider>
            </NotificationsProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
